import { Col, Form, Input, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import { useSettings } from "../../../api/hooks";
import { useEffect, useState } from "react";
import { useContacts } from "../../../api/hooks/customer";

const emptyReceiverAddress = {
  name: "",
  address: {
    street: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  },
};

function OrderReceiverAddress({
  errors,
  control,
  watch,
  setValue,
  orderDetails,
}) {
  const [customerDetails, setCustomerDetails] = useState();
  const { data: settingDetails, isLoading: isLoadingSettingDetails } =
    useSettings();

  const { data: customerList, isLoading: isLoadingCustomerList } = useContacts({
    params: {
      type: ["CUSTOMER", "PROCESSOR"],
    },
  });

  const customer = watch("customer");
  const receiver_address_name = watch("receiverAddress.name");
  const receiver_address_address = watch("receiverAddress.address");

  // console.log("customer----->", customer);
  // console.log("customerDetails----->", customerDetails);

  const handleCleantecAddressChange = (value) => {
    const selectedWarehouse = settingDetails?.warehouses?.find(
      (addr) => addr._id === value,
    );
    if (selectedWarehouse) {
      setValue("receiverAddress.name", selectedWarehouse?.name);
      setValue("receiverAddress.address", selectedWarehouse.address);
    }
  };

  useEffect(() => {
    if (customer && !isLoadingCustomerList) {
      const foundCustomerDetails = customerList?.find(
        (c) => c?._id === customer,
      );
      if (!foundCustomerDetails) {
        return;
      }
      setCustomerDetails(foundCustomerDetails);
      if (foundCustomerDetails?.type === "CUSTOMER") {
        setValue("receiverAddress", {
          name: foundCustomerDetails?.name,
          address: foundCustomerDetails?.address,
        });
      } else {
        // reset the values on customer change
        // console.log(
        //   "orderDetails?.receiverAddress || emptyReceiverAddress",
        //   orderDetails?.receiverAddress || emptyReceiverAddress,
        // );
        setValue(
          "receiverAddress",
          orderDetails?.receiverAddress?.name
            ? orderDetails.receiverAddress
            : emptyReceiverAddress,
        );
      }
    }
  }, [customer]);

  if (!customerDetails) {
    return null;
  }

  return (
    <>
      <Col span={24}>
        <div className="mb-4 flex items-center gap-2">
          <p className="">Delivery Address</p>
          {customerDetails?.type === "PROCESSOR" && (
            <Form.Item className="mb-0 min-w-60">
              <Controller
                control={control}
                name="warehouse"
                render={({ field }) => (
                  <Select
                    {...field}
                    placeholder="Select Cleantec Address"
                    options={settingDetails?.warehouses?.map((item) => {
                      return {
                        value: item?._id,
                        label: item?.name,
                      };
                    })}
                    onChange={handleCleantecAddressChange}
                    loading={isLoadingSettingDetails}
                    allowClear={true}
                  />
                )}
              />
            </Form.Item>
          )}
        </div>
      </Col>

      <Col span={24} className="mb-6">
        <Row gutter={18}>
          {/* <Col span={24}>
            <Form.Item
              label="Name"
              validateStatus={errors.receiverAddress?.name ? "error" : ""}
              help={errors.receiverAddress?.name?.message}
              required
            >
              <Controller
                control={control}
                name={`receiverAddress.name`}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="Name"
                    disabled={true}
                    // disabled={customerDetails?.type === "CUSTOMER"}
                  />
                )}
              />
            </Form.Item>
          </Col> */}

          <Col span={1}></Col>
          {receiver_address_name && (
            <Col span={23}>Name: {receiver_address_name}</Col>
          )}
          <Col span={1}></Col>
          {receiver_address_address?.street && (
            <Col span={23}>
              Address: {receiver_address_address?.street},{" "}
              {receiver_address_address?.city},{" "}
              {receiver_address_address?.state} -{" "}
              {receiver_address_address?.zipCode},{" "}
              {receiver_address_address?.country}
            </Col>
          )}

          {/* <Col span={12}>
            <Form.Item
              label="Street"
              validateStatus={
                errors.receiverAddress?.address?.street ? "error" : ""
              }
              help={errors.receiverAddress?.address?.street?.message}
              required
            >
              <Controller
                control={control}
                name={`receiverAddress.address.street`}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="Street"
                    disabled={true}
                    // disabled={customerDetails?.type === "CUSTOMER"}
                  />
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="City"
              validateStatus={
                errors.receiverAddress?.address?.city ? "error" : ""
              }
              help={errors.receiverAddress?.address?.city?.message}
              required
            >
              <Controller
                control={control}
                name={`receiverAddress.address.city`}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="City"
                    disabled={true}
                    // disabled={customerDetails?.type === "CUSTOMER"}
                  />
                )}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="State"
              validateStatus={
                errors.receiverAddress?.address?.state ? "error" : ""
              }
              help={errors.receiverAddress?.address?.state?.message}
              required
            >
              <Controller
                control={control}
                name={`receiverAddress.address.state`}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="State"
                    disabled={true}
                    // disabled={customerDetails?.type === "CUSTOMER"}
                  />
                )}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Zip Code"
              validateStatus={
                errors.receiverAddress?.address?.zipCode ? "error" : ""
              }
              help={errors.receiverAddress?.address?.zipCode?.message}
              required
            >
              <Controller
                control={control}
                name={`receiverAddress.address.zipCode`}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="Zip Code"
                    disabled={true}
                    // disabled={customerDetails?.type === "CUSTOMER"}
                  />
                )}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Country"
              validateStatus={
                errors.receiverAddress?.address?.country ? "error" : ""
              }
              help={errors.receiverAddress?.address?.country?.message}
              required
            >
              <Controller
                control={control}
                name={`receiverAddress.address.country`}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="Country"
                    disabled={true}
                    // disabled={customerDetails?.type === "CUSTOMER"}
                  />
                )}
              />
            </Form.Item>
          </Col> */}
        </Row>
      </Col>
    </>
  );
}

export default OrderReceiverAddress;
